export default __webpack_public_path__ + "static/media/feature-refine.e1e410d8.webp";